import { doesExist } from 'utils/tsHelpers';
import { useAddRequirement } from './useAddRequirement';
import { getFieldTypeFromFieldMappings } from '../../utils';
import { useQueryStateContext } from '../../contexts';
import { createBlankCondition, createBlankRequirement } from '../../utils';
import { ClientDataType } from '../../types';
import { useFieldMappingsContext } from '../../contexts/fieldMappings';

export const useAddRequirementFromSelect = () => {
  const { defaultCombinator: combinator, setToLatestId } = useQueryStateContext();
  const { userEventMappings } = useFieldMappingsContext();

  const addRequirement = useAddRequirement();
  return ({
    dataType,
    userProfileField,
  }: {
    dataType: ClientDataType;
    userProfileField?: string;
  }) => {
    if (dataType === ClientDataType.User && doesExist(userProfileField)) {
      const fieldType = getFieldTypeFromFieldMappings(
        userProfileField,
        userEventMappings,
        dataType,
      );
      const condition = createBlankCondition(dataType, {
        fieldType,
        field: userProfileField,
      });

      addRequirement(
        createBlankRequirement({
          dataType,
          searchCombo: {
            combinator,
            searchQueries: [condition],
          },
        }),
      );
      setToLatestId(condition.id);
    } else {
      const condition = createBlankCondition(dataType);
      addRequirement(
        createBlankRequirement({
          dataType,
          searchCombo: {
            combinator,
            searchQueries: [condition],
          },
        }),
      );
      setToLatestId(condition.id);
    }
  };
};
